import { render, staticRenderFns } from "./compFormInput.vue?vue&type=template&id=a5fba0b8&scoped=true&"
import script from "./compFormInput.vue?vue&type=script&lang=js&"
export * from "./compFormInput.vue?vue&type=script&lang=js&"
import style0 from "./compFormInput.vue?vue&type=style&index=0&id=a5fba0b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fba0b8",
  null
  
)

export default component.exports